/* Josh enquiry delivery guard, v3.2.
 * Applies only to GCCVChatLeadForm. Delegates to Shopify's supported CAPTCHA API
 * and the original requestSubmit method. Never bypasses CAPTCHA or auto-retries.
 * Recovery data is kept in this browser tab for at most 30 minutes after Send.
 */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;
  const KEY = 'gccv-josh-pending-enquiry-v1';
  const TTL = 30 * 60 * 1000;
  const FIELDS = ['contact[name]', 'contact[phone]', 'contact[email]', 'contact[body]',
    'contact[Source]', 'contact[NJS referral consent]', 'contact[Enquiry reference]'];
  function mount() {
    const root = document.getElementById('gccv-chatbot');
    const form = document.getElementById('GCCVChatLeadForm');
    if (!root || !form || form.dataset.deliveryGuard) return;
    const dialog = root.querySelector('dialog');
    const panel = root.querySelector('[data-body]');
    const controls = root.querySelector('[data-controls]');
    if (!dialog || !panel || !controls || typeof form.requestSubmit !== 'function') return;
    form.dataset.deliveryGuard = '3.2';
    const nativeRequestSubmit = form.requestSubmit.bind(form);
    let busy = false, attempt = 0, watchdog, expiryTimer, pending = readPending();
    const element = (tag, text) => { const n = document.createElement(tag); n.textContent = text; return n; };
    function clearPending() { clearTimeout(expiryTimer); try { sessionStorage.removeItem(KEY); } catch (_) {} pending = null; }
    function readPending() {
      try {
        const p = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (p && p.values && typeof p.createdAt === 'number' && Date.now() - p.createdAt < TTL && Date.now() >= p.createdAt) return p;
        sessionStorage.removeItem(KEY);
      } catch (_) {}
      return null;
    }
    function savePending(p) { pending = p; clearTimeout(expiryTimer); try { sessionStorage.setItem(KEY, JSON.stringify(p)); } catch (_) {} expiryTimer = setTimeout(clearPending, Math.max(0, TTL - (Date.now() - p.createdAt))); }
    function field(name) {
      let f = form.elements.namedItem(name);
      if (!f) { f = document.createElement('input'); f.type = 'hidden'; f.name = name; form.append(f); }
      return f;
    }
    function reference() {
      if (globalThis.crypto && typeof globalThis.crypto.randomUUID === 'function') return 'JOSH-' + crypto.randomUUID().slice(0, 8).toUpperCase();
      return 'JOSH-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
    }
    function takeSnapshot() {
      const r = field('contact[Enquiry reference]');
      if (!r.value) r.value = reference();
      const values = {};
      FIELDS.forEach(name => { values[name] = String(field(name).value || '').slice(0, 20000); });
      return {createdAt: Date.now(), values};
    }
    function restore(p) { FIELDS.forEach(name => { field(name).value = String(p.values[name] || ''); }); }
    function enquiryText(p) {
      return 'Josh website enquiry\nReference: ' + (p.values['contact[Enquiry reference]'] || '') + '\n\n' + (p.values['contact[body]'] || '');
    }
    function show(message, p, recovery) {
      panel.replaceChildren(); controls.replaceChildren();
      const status = element('p', message); status.className = 'gccv-note'; status.setAttribute('role', 'status'); panel.append(status);
      if (p) {
        panel.append(element('p', 'Enquiry reference: ' + p.values['contact[Enquiry reference]']));
        if (recovery) {
          const summary = element('pre', enquiryText(p)); summary.className = 'gccv-summary'; panel.append(summary);
          const email = element('a', 'Open an email with my enquiry'); email.className = 'gccv-link';
          email.href = 'mailto:goldcoastcampervans@gmail.com?subject=' + encodeURIComponent('Josh enquiry ' + p.values['contact[Enquiry reference]']) + '&body=' + encodeURIComponent(enquiryText(p));
          panel.append(email);
          const note = element('p', 'This opens your email app. You must tap Send there. If the message is too long to open, copy it below.'); note.className = 'gccv-disclosure'; panel.append(note);
          const copy = element('button', 'Copy my enquiry'); copy.type = 'button'; copy.className = 'gccv-choice';
          copy.addEventListener('click', async () => {
            try { await navigator.clipboard.writeText(enquiryText(p)); copy.textContent = 'Enquiry copied'; }
            catch (_) { const text = document.createElement('textarea'); text.value = enquiryText(p); text.readOnly = true; text.rows = 8; text.setAttribute('aria-label', 'Select and copy your enquiry'); panel.append(text); text.focus(); text.select(); }
          }); panel.append(copy);
          const retry = element('button', 'Retry sending — may send a duplicate'); retry.type = 'button'; retry.className = 'gccv-choice';
          retry.addEventListener('click', () => { if (!busy) { restore(p); send(); } }); panel.append(retry);
        }
      }
      if (!dialog.open) dialog.showModal();
      root.querySelector('[data-open]').setAttribute('aria-expanded', 'true');
      panel.scrollTop = 0;
    }
    function fail(message, p, id) {
      if (id !== attempt) return;
      busy = false; clearTimeout(watchdog); form.dispatchEvent(new Event('gccv:delivery-failed')); show(message, p, true);
    }
    function send(submitter) {
      if (busy) return;
      const email = field('contact[email]');
      if (!email.value || !email.checkValidity() || !field('contact[body]').value.trim()) {
        form.dispatchEvent(new Event('gccv:delivery-failed'));
        show('We could not send this enquiry because contact details are missing or invalid. Please call our team.', null, false); return;
      }
      const p = takeSnapshot(); savePending(p);
      busy = true; const id = ++attempt;
      show('Preparing the security check. Your enquiry has not been confirmed as sent yet.', p, false);
      const deadline = Date.now() + 8000;
      const waitForShopify = () => {
        if (id !== attempt) return;
        const captcha = globalThis.Shopify && globalThis.Shopify.captcha;
        if (!captcha || typeof captcha.protect !== 'function') {
          if (Date.now() < deadline) { setTimeout(waitForShopify, 200); return; }
          fail('The security check could not start. Your enquiry was not submitted by this attempt. You can email the details below or try again.', p, id); return;
        }
        let ready = false;
        watchdog = setTimeout(() => fail('We have not received confirmation from Shopify. Please do not assume your enquiry was sent. Your details are shown below so you can email them or retry.', p, id), 30000);
        try {
          captcha.protect(form, () => {
            if (id !== attempt || !busy || ready) return; ready = true;
            show('Sending your enquiry through Shopify. Please complete any security check that appears. Keep this page open until a result is shown.', p, false);
            try { nativeRequestSubmit(submitter); }
            catch (_) { fail('The form could not be submitted. Please email the enquiry below or retry.', p, id); }
          });
        } catch (_) { fail('The security check could not finish. Please email your enquiry below or retry.', p, id); }
      };
      waitForShopify();
    }
    // The existing chatbot calls this only after the customer chooses Send my enquiry.
    // Preserve all existing Shopify form submit listeners and protection.
    form.requestSubmit = send;
    const isReturn = window.location.hash === '#GCCVChatLeadForm' || new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    if (pending) savePending(pending);
    if (pending && isReturn && form.querySelector('[data-form-success]')) {
      const p = pending; clearPending();
      show('Thank you — Shopify has accepted your enquiry. This confirms the form was submitted, not delivery to an email inbox. Our team will review it; no booking or finance approval is confirmed.', p, false);
    } else if (pending && isReturn && form.querySelector('[data-form-error]')) {
      restore(pending); show('Shopify reported a problem with your enquiry. Delivery is not confirmed. You can email the details below or retry.', pending, true);
    } else if (pending) {
      restore(pending); show('Your last enquiry has no confirmed submission result in this tab. It may or may not have been received. Check before retrying, or email a copy using the details below.', pending, true);
    }
    window.addEventListener('pagehide', () => clearTimeout(watchdog));
    // Do not leave personal details in tab storage after the user clears the chat.
    root.addEventListener('gccv:josh-reset', () => {
      clearPending();
      clearTimeout(watchdog);
      attempt++;
      busy = false;
      ['contact[name]', 'contact[phone]', 'contact[email]', 'contact[body]', 'contact[Enquiry reference]'].forEach(name => { field(name).value = ''; });
      field('contact[NJS referral consent]').value = 'No consent to share with NJS Financial';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
  document.addEventListener('shopify:section:load', mount);
})();
